import { DisplayControlGroup } from 'features/DisplayControlGroup/models';
import axiosClient from 'utils/axiosClient';

export interface Response {
  status: string;
  message: string;
  data: DisplayControlGroup[];
}

const config = {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
};

const service = {
  getDisplayControlGroup(id: string): Promise<Response> {
    const url = `control-group-menu/${id}/`;
    return axiosClient.get(url);
  },
  updateDisplayControlGroup(body: DisplayControlGroup): Promise<Response> {
    let url;
    if (body.id === 0) {
      url = `control-group-menu/`;
      return axiosClient.post(url, body, config);
    } else {
      console.log(body.id);
      url = `control-group-menu/${body.id}/`;
      return axiosClient.put(url, body, config);
    }
  },
};

export default service;
